export const LOCAL_STORAGE_KEY = {
  STATE: "black-friday-state",
  TOKENS: "tokens"
};
